var map = {
	"./fr/event.js": 1196
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1391;



//////////////////
// WEBPACK FOOTER
// ./src/locales ^\.\/.*\/event\.js$
// module id = 1391
// module chunks = 0